import {Suspense, useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_myb/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_myb/layout/core'
import {MasterInit} from '../_myb/layout/MasterInit'
import {AuthInit} from './modules/auth'
import {ThemeModeProvider} from '../_myb/partials'
import { useLocation } from 'react-router-dom';
// import { getAnalytics, logEvent } from 'firebase/analytics';
import { AppProvider } from './modules/apps/AppContext'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import { initializeAnalytics, trackPageview } from './modules/apps/analytics'
import { setFavicon } from './utils/SetFavico'
import { brandSettings } from './modules/settings/BrandSettings'

initializeAnalytics();

const App = () => {
  useEffect(() => {
    // Track pageview on route change
    trackPageview(location.pathname);
}, [location]);

useEffect(() => {
  setFavicon(brandSettings.favicon);
}, []);

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      {/* <AppProvider> */}
      <I18nProvider>
      <ToastContainer
            position="bottom-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            />
        <LayoutProvider>
          <ThemeModeProvider>
            <AuthInit>
              <Outlet />
              <MasterInit />
            </AuthInit>
          </ThemeModeProvider>
        </LayoutProvider>
      </I18nProvider>
      {/* </AppProvider> */}
    </Suspense>
  )
}

export {App}
